import React from 'react';

interface ShotsSectionProps {
  hoveredTheyShot: string | null;
  curGoalStatus: boolean;
  usGoalClicked: boolean;
  themGoalClicked: boolean;
  onGoalClick: () => void;
  onTheyGoalClick: () => void;
  onUsSavedClick: () => void;
  onUsMissedClick: () => void;
  onUsBlockedClick: () => void;
  onTheySavedClick: () => void;
  onTheyMissedClick: () => void;
  onTheyBlockedClick: () => void;
  setHoveredTheyShot: (val: string | null) => void;
  actionFeedback?: string | null;
  theyMissedDisabled?: boolean;
}

const ShotsSection: React.FC<ShotsSectionProps> = ({
  hoveredTheyShot,
  curGoalStatus,
  usGoalClicked,
  themGoalClicked,
  onGoalClick,
  onTheyGoalClick,
  onUsSavedClick,
  onUsMissedClick,
  onUsBlockedClick,
  onTheySavedClick,
  onTheyMissedClick,
  onTheyBlockedClick,
  setHoveredTheyShot,
  actionFeedback,
  theyMissedDisabled = false,
}) => (
  <div className="flex flex-col gap-2 px-3">
    <div className="flex w-full justify-between mb-4 z-10">
      <div className="w-1/2 text-center text-xl font-bold">We Shot</div>
      <div className="w-1/2 text-center text-xl font-bold">They Shot</div>
    </div>
    <div className="flex w-full gap-6 z-10">
      {/* We Shot column */}
      <div className="flex-1 items-center flex flex-col gap-5">
        <button
          className={`w-full font-bold rounded-lg py-3 text-xl md:text-2xl shadow-md transition-all text-black
            ${usGoalClicked ? 'bg-[#FFD700]' : 'bg-[#7fe526]'}`}
          onClick={onGoalClick}
        >
          GOAL
        </button>
        <button
          className="w-full font-bold rounded-lg py-3 text-xl md:text-2xl shadow-md transition-all bg-[#7fe526] text-black"
          onClick={onUsSavedClick}
        >
          SAVED
        </button>
        <button
          className="w-full font-bold rounded-lg py-3 text-xl md:text-2xl shadow-md transition-all bg-[#7fe526] text-black"
          onClick={onUsMissedClick}
        >
          MISSED
        </button>
        <button
          className="w-full font-bold rounded-lg py-3 text-xl md:text-2xl shadow-md transition-all bg-[#7fe526] text-black"
          onClick={onUsBlockedClick}
        >
          BLOCKED
        </button>
      </div>
      {/* They Shot column */}
      <div className="flex-1 items-center flex flex-col gap-5">
        <button
          className={`w-full font-bold rounded-lg py-3 text-xl md:text-2xl shadow-md transition-all
            ${themGoalClicked ? 'bg-white text-black' : 'bg-[#294e87] text-white'}`}
          onClick={onTheyGoalClick}
        >
          GOAL
        </button>
        <button
          className={`w-full font-bold rounded-lg py-3 text-xl md:text-2xl shadow-md transition-all ${
            actionFeedback === 'THEY_SHOT_SAVED' ? 'bg-white text-black' : 'bg-[#294e87] text-white'
          }`}
          onClick={onTheySavedClick}
        >
          SAVED
        </button>
        <button
          className={`w-full font-bold rounded-lg py-3 text-xl md:text-2xl shadow-md transition-all ${
            actionFeedback === 'THEY_SHOT_MISSED' ? 'bg-white text-black' : 'bg-[#294e87] text-white'
          } ${theyMissedDisabled ? 'opacity-60 cursor-not-allowed' : ''}`}
          onClick={onTheyMissedClick}
          disabled={theyMissedDisabled}
        >
          MISSED
        </button>
        <button
          className="w-full font-bold rounded-lg py-3 text-xl md:text-2xl shadow-md transition-all bg-[#294e87] text-white"
          onClick={onTheyBlockedClick}
        >
          BLOCKED
        </button>
      </div>
    </div>
  </div>
);

export default ShotsSection;
